import styled, { css } from 'styled-components';
import * as InfiniteScroll from 'react-infinite-scroller';

import { spin } from '../../utils/style';
import { hexToRgba } from '../../utils/style';
import { Format, StyleColor, BaseStyledComponentProps } from '../../utils/styles-constants';
import { BottomBarHeight } from '../Page/styles';

interface DriveItemListContainerProps {
	isEmpty: boolean;
	hasBottomBar: boolean;
}

const DriveItemListContainer = styled('div')`
	display: flex;
	flex-direction: column;

	${(props: DriveItemListContainerProps) => !props.isEmpty && `
		flex: 1;
		overflow-x: hidden;
		overflow-y: auto;
	`}

	${(props: DriveItemListContainerProps) => props.hasBottomBar && !props.isEmpty && `padding-bottom: ${BottomBarHeight};`}
`;

interface StyledDriveItemList {
	showSearchField: boolean;
	isEditMode: boolean;
	isCoverFlow: boolean;
}

const StyledDriveItemList = styled('div')`
	flex: 1;
	display: flex;
	flex-flow: column nowrap;
	overflow-x: hidden;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	padding: ${(props: StyledDriveItemList) => props.isCoverFlow ? '0' : '0 38px'};

	${(props: StyledDriveItemList) => props.showSearchField && 'margin-top: 60px;'}

	${(props: StyledDriveItemList) => props.isEditMode && 'user-select: none;'}

	@media ${Format.Smartphone}, ${Format.SmartphoneLandscape} {
		padding: ${(props: StyledDriveItemList) => props.isCoverFlow ? '0' : '0 22px'};
	}
`;

const ListStatus = styled('h2') `
	padding-left: 9px;
`;

const LoadingStatus = styled('div') `${css`
	margin: 10px 9px;
	font-size: 21px;
	font-weight: bold;
	display: flex;
	align-items: center;

	& > svg {
		height: 35px;
		width: 35px;
		animation: ${spin};
		margin-right: 20px;
	}
`}`;

const StyledInfiniteScroll = styled(InfiniteScroll)`
	display: flex;
	flex-flow: row wrap;
	transform: translate3d(0,0,0);
`;

const TitleWrapper = styled('div')`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	padding: 20px 38px 10px 38px;

	@media ${Format.Smartphone}, ${Format.SmartphoneLandscape} {
		padding: 20px 22px 10px 22px;
	}
`;

const ButtonsWrapper = styled('div')`
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	flex: 0 0 auto;
	flex-grow: 1;
	margin-left: 10px;
`;

interface ButtonEdit extends BaseStyledComponentProps {
	isEditMode: boolean;
}

const ButtonEdit = styled('button')`
	min-width: 50px;
	padding: 5px 10px;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 12px;
	line-height: 20px;
	background-color: transparent;
	color: ${ (props: ButtonEdit) => props.isEditMode
		? StyleColor.Green
		: props.theme.primary.actionColor
	};
	cursor: pointer;
`;

const Loader = styled('div')`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	font-size: 21px;
	background-color: ${hexToRgba(StyleColor.White, 80)};

	svg {
		height: 35px;
		width: 35px;
		animation: ${spin};
		margin-right: 20px;
	}
`;

export {
	DriveItemListContainer,
	ListStatus,
	LoadingStatus,
	StyledDriveItemList,
	StyledInfiniteScroll,
	TitleWrapper,
	ButtonsWrapper,
	ButtonEdit,
	Loader,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/styles.ts